<div class="pb-1 title" *ngIf="title">{{ title }}</div>
<div [innerHtml]="message"></div>
<ng-content></ng-content>
